import { Card, Typography } from "antd"
import React from "react"

import type { SummaryStat } from "./_helpers.ts"

interface TopSummarySectionProps {
  stats: SummaryStat[]
  labelFor: (stat: SummaryStat) => string
}

export const TopSummarySection = ({
  stats,
  labelFor
}: TopSummarySectionProps) => (
  <div className={"grid grid-cols-2 gap-2"} data-testid={"mobile-home-summary"}>
    {stats.map((stat) => (
      <Card key={stat.key} size={"small"} styles={{ body: { padding: 12 } }}>
        <Typography.Text
          type={"secondary"}
          className={"block text-xs uppercase"}
        >
          {labelFor(stat)}
        </Typography.Text>
        <Typography.Text strong className={"block text-2xl leading-tight"}>
          {stat.value}
        </Typography.Text>
      </Card>
    ))}
  </div>
)
